import React, { useEffect, useState } from 'react';
import moment from 'moment';
import {
    Button,
    Checkbox,
    Row,
    Col,
    Input,
    message,
    Table,
    Popconfirm,
    Popover,
} from 'antd'
import {
    PlusOutlined,
    CheckCircleTwoTone, 
    SyncOutlined
} from '@ant-design/icons';
import { isEmpty, isNotEmpty, samplingConstants, toThousands } from '../Service/Utils';
import UIFetchService from '../Service/UIFetchService';
import auth from '../Service/AuthFetchService';
import './EventAnalysis.css'

const FunnelAnalysisView = () => {

    return (
        <div style={{ padding: '20px 10px' }}>
            <FunnelListView />
        </div>
    )
}

function FunnelListView(props) {
    const [keyword, setKeyword] = useState(null)
    const [onlyMe, setOnlyMe] = useState(false)
    const [funnelList, setFunnelList] = useState([])
    const [total, setTotal] = useState(0)
    const [current, setCurrent] = useState(1)
    const [pageSize, setPageSize] = useState(20)
    const [user, setUser] = useState(null)

    useEffect(() => {
        if (user == null) {
            auth.authenticate()
                .then((result) => {
                    if (result) {
                        setUser(result)
                    }
                })
        }
        _refreshFunnelList(1)
    }, [keyword, onlyMe])

    useEffect(() => {
        if (user != null) {
            window.CyaLogger?.sendCustomEvent('page_view', '漏斗分析', 'list_view', {
                event_date: moment().format('YYYY-MM-DD'),
                user_name: user.account
            })
        }
    }, [user])

    const _refreshFunnelList = (pidx, psz, filters) => {
        const queries = []
        if (pidx) {
            setCurrent(pidx)
            queries.push(`pageIndex=${pidx}`)
        } else {
            queries.push(`pageIndex=${current}`)
        }
        if (psz) {
            setPageSize(psz)
            queries.push(`pageSize=${psz}`)
        } else {
            queries.push(`pageSize=${pageSize}`)
        }
        if (keyword != null && isNotEmpty(keyword)) {
            queries.push(`keyword=${keyword}`)
        }
        if (onlyMe) {
            queries.push(`onlyMe=true`)
        }
        if (filters) {
            queries.push(`filters=${encodeURI(JSON.stringify(filters))}`)
        }

        UIFetchService.get(`/api/v1/sampling/funnel/queryList?${queries.join('&')}`)
            .then((rv) => {
                if (rv) {
                    setTotal(rv.total)
                    rv.items.forEach(it => {
                        const project = samplingConstants.projects.filter(p => p.value == it.projectName)
                        if (project != null) {
                            it.projectNameCn = project[0].title
                        }
                    })
                    setFunnelList(rv.items)
                }
            })
    }

    const funnelColumns = [
        {
            title: '',
            key: 'status',
            render: (_, record) => {
                if (record.status == 1) {
                    return <Popover content="漏斗计算完成"><CheckCircleTwoTone twoToneColor="#52c41a" /></Popover>
                } else {
                    return <Popover content="漏斗计算中，请计算完成后查看"><SyncOutlined spin style={{ color: '#fadb14' }} /></Popover>
                }
            }
        },
        {
            title: "漏斗名称",
            dataIndex: "name",
            render: (_, record) => {
                if (record.status === 2) {
                    return <span>{record.name}</span>
                } else {
                    return <Button type='link' 
                            onClick={() => {
                                window.CyaLogger?.sendClick('漏斗分析', 'list_click', {
                                    event_date: moment().format('YYYY-MM-DD'),
                                    user_name: user.account,
                                    funnel_name: record.name,
                                    funnel_id: record.funnelId
                                })
                                window.location = `/real_time/funnel_analysis/data/${record.funnelId}`
                            }}
                        >
                        {record.name}
                        </Button>
                }
            }
        },
        {
            title: "所属团队",
            dataIndex: "projectNameCn",
            key: "projectName",
            filters: samplingConstants.projects.map(t => { return { text: t.title, value: t.value } }),
            onFilter: (value, rd) => {
                if (isEmpty(rd.projectName)) {
                    return false;
                }
                return rd.projectName.indexOf(value) >= 0;
            }
        },
        {
            title: "创建人",
            dataIndex: "creator"
        },
        {
            title: "创建时间",
            dataIndex: "createdAt",
            render: (time) => moment(time).format('YYYY-MM-DD HH:mm:ss')
        },
        {
            title: "更新时间",
            dataIndex: "updatedAt",
            render: (time) => moment(time).format('YYYY-MM-DD HH:mm:ss')
        },
        {
            title: "计算方式",
            dataIndex: "calcTypeName"
        },
        {
            title: "操作",
            key: "operate",
            fixed: "right",
            render: (_, record) => <> {record.owned ? <Row>
                <Col flex="45px">
                {record.status === 2 ? <span></span> : 
                    <Button
                        type="link"
                        size='small'
                        onClick={() => {
                            window.location = `/real_time/funnel_analysis/edit/${record.funnelId}`
                        }}
                    >编辑</Button>
                }
                </Col>
                <Col>
                <Popconfirm
                    title="是否删除指定的漏斗？"
                    onConfirm={() => {
                        UIFetchService.method('PATCH', `/api/v1/sampling/funnel/${record.funnelId}/delete/`)
                            .then((cnt) => {
                                if (cnt != null) {
                                    message.success("删除漏斗成功")
                                    _refreshFunnelList()
                                } else {
                                    message.error("删除漏斗失败")
                                }
                            })
                    }}
                    onCancel={() => { }}
                    okText="删除"
                    okButtonProps={{ danger: true }}
                    cancelText="取消"
                >
                    <Button size='small' type="link" danger >删除</Button>
                </Popconfirm>
                </Col>
            </Row> : null}
            </>
        }
    ]

    return (
        <>
            <Row>
                <Col flex="300px" style={{ paddingLeft: 10}}>
                    <Input.Search
                        value={keyword}
                        onChange={async ({ target: { value } }) => {
                            setKeyword(value)
                        }}
                        style={{ width: '100%' }}
                        placeholder="输入漏斗名称/创建人员搜索"
                    />
                </Col>
                <Col flex="100px" style={{ paddingTop: 5 }}>
                    <Checkbox onChange={(e) => {
                        setOnlyMe(e.target.checked)
                    }}>只看我的</Checkbox>
                </Col>
                <Col flex="auto"></Col>
                <Col flex="100px" style={{ paddingRight: 10}}>
                    <Button 
                        icon={<PlusOutlined />} 
                        type='primary' 
                        onClick={() => {
                            window.CyaLogger?.sendClick('漏斗分析', 'xinjian_button_click', {event_date: moment().format('YYYY-MM-DD'), user_name: user.account })
                            window.location = '/real_time/funnel_analysis/new'
                        }} >
                        新建漏斗
                    </Button>
                </Col>
            </Row>
            <Row>
                <Col flex="100%" style={{ padding: '10px' }}>
                    <Table
                        dataSource={funnelList}
                        columns={funnelColumns}
                        bordered
                        size="small"
                        pagination={{
                            total: total,
                            current: current,
                            pageSize: pageSize,
                        }}
                        rowKey="id"
                        style={{
                            width: '100%',
                        }}
                        onChange={(pagination, filters, sorter, { action }) => {
                            _refreshFunnelList(pagination.current, pagination.pageSize, filters)
                        }}
                    />
                </Col>
            </Row>
        </>
    )
}

export default FunnelAnalysisView